import { Box, IconButton, MenuItem, Select, Typography } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import React from 'react'

const paginationStyle = {
  pagination:{
    fontSize: '0.875rem',
    color: '#303030'
  },
  iconPagination: {
    padding: 0,
    color:'#303030'
  },
  SelectOptions:{
    fontSize: {xs:'0.875rem', md:'1rem'}
  },
  pageNumber: {
    padding: {xs:'0.469rem 3.217rem', md: '0.688rem 1.155rem'},
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    background: '#FFFEFC',
    fontSize:'1rem'
  }
};

function PaginationSection({
    rows,
    page, 
    rowsPerPage,
    totalPages,
    onPageChange,
    onRowsPerPageChange,
    isLoading,
    options = [25, 50, 75, 100]
}) {

    const handleBackButton = () => {
        onPageChange(page - 1);
    };

    const handleNextButton = () => {
        onPageChange(page + 1);
    };

    const handleRowsPerPageChange = (evt) => {
        onRowsPerPageChange(evt.target.value);
    };

    return (
        <>
            <Box sx={{py:{xs:'1.5rem', md:'2rem'}, display:'flex', flexDirection: {xs:'column', sm: 'row'}, justifyContent:'space-between' }}>
                <Box>
                    <Typography sx={{ display: {xs: 'block', sm: 'none' }, textAlign:'center', color: '#676565', pb:'1.2rem', fontSize: paginationStyle.pagination.fontSize }}>{`Mostrando ${rows.length} resultados`}</Typography>
                    <Select
                        sx={{
                        display:{xs:'none', sm:'inline-flex'},
                        backgroundColor:'#FFFEFC', 
                        fontSize: {xs:'0.875rem', md:'1rem'},
                        '& .MuiSelect-select': {
                            paddingRight: '0.75rem !important', 
                        },
                        }}
                        IconComponent={() => <KeyboardArrowLeft sx={{transform: 'rotate(270deg)', mr: '0.75rem' }}/>}
                        MenuProps={{
                        MenuListProps:{
                            fontSize: '5px'
                        }
                        }}
                        value={rowsPerPage}
                        onChange={handleRowsPerPageChange}
                        disabled={isLoading}
                    >
                        {
                            options.map((option, index) => (
                                <MenuItem key={index} sx={paginationStyle.SelectOptions} value={option}>{option} resultados</MenuItem>
                            ))
                        }
                    </Select>
                </Box>
                <Box sx={{ display:'flex', alignItems:'center', gap:{xs:'0rem', sm:'0.5rem', md:'0.75rem'}, justifyContent:{xs: 'space-between', sm:'unset'} }}>
                    <IconButton
                        sx={paginationStyle.iconPagination}
                        onClick={handleBackButton}
                        disabled={page === 1 || isLoading}
                    >
                        <KeyboardArrowLeft/>
                    </IconButton>
                    <Typography sx={paginationStyle.pagination}>Página</Typography>
                    <Typography sx={paginationStyle.pageNumber}>{page}</Typography>
                    <Typography sx={paginationStyle.pagination}>{`de ${totalPages}`}</Typography>
                    <IconButton
                        sx={paginationStyle.iconPagination}
                        onClick={handleNextButton}
                        disabled={page === totalPages || isLoading}
                    >
                        <KeyboardArrowRight/>
                    </IconButton>
                </Box>
            </Box>
        </>
    )
}

export default PaginationSection